import { ID, SC, SC_DATA, WINDOW_WIDTH } from "src/libs/interfaces/layouts"
import { Gallery } from "src/libs/useful"
import { ButtonContent, ContactsContent, IMenuContact, LANDING_TYPE_CONTENT } from "src/modules/pe-landing-module/data/interfaces"
import useComponentData from "src/modules/pe-landing-module/hooks/useComponentData"
import useLandingSize from "src/modules/pe-landing-module/hooks/useLandingSize"
import { IPrimitiveProps } from "../section/Primitive"
import ButtonPrimitive from "./ButtonPrimitive"
import ContactsEditorForm from "../landing-edit/editors/contacts"

/* Protopia Ecosystem component */ 
const ContactsPrimitive = ( props: IPrimitiveProps ): JSX.Element => { 
    const {width} = useLandingSize()
    if( width > WINDOW_WIDTH.TABLET ) {
        return <ContactsScreenPrimitive {...props} />
    }
    else {
        return <ContactsMobilePrimitive {...props} />
    }
}
export default ContactsPrimitive

const ContactsScreenPrimitive = (props: IPrimitiveProps): JSX.Element => { 
    const primitive: ContactsContent = useComponentData<ContactsContent>(( props.primitive || {dimentions: {}} ) as ContactsContent )  
    const items: IMenuContact[] = primitive.items?.length  
        ?
        primitive.items
        :
        []    
    return !!items.length
        ?
        <div 
            className={`pe-primitive-container landing-contacts-primitive p-1 ${primitive.className || ""}`} 
            data-primitive-type={primitive["data-primitive-type"]}
        >  
            <div className="flex-centered"> 
                {
                    primitive.carousel_count
                    ?
                    <ContactsMobilePrimitive {...props} /> 
                    :
                    items 
                        .map((item, i) => {
                            const _cs = (item.cs || item.sc || SC.LINK);
                            const _primitive : ButtonContent = { 
                                id: (_cs + item.id) as ID,
                                type: LANDING_TYPE_CONTENT.BUTTON,
                                items: items,
                                label: item.label,
                                icon: `${ item.sc === SC.AT ? "fas" : "fab" } fa-${ item.sc === SC.TELEGRAM ? `${item.sc}-plane` : item.sc}`,
                                button_color: SC_DATA[_cs as keyof typeof SC_DATA].color,
                                text_color: item.text_color || primitive.text_color,
                                className: !!item.sc ? `soc hover ${ item.sc } ${ item.className }` : ``,
                                style: { ...primitive.style, ...item.style },
                                url: item.url,
                                image: item.image,
                                width: item.width || primitive.size,
                                height: item.height || primitive.size,
                                border_width: item.border_width || primitive.border_width,
                                design_type: item.design_type || primitive.design_type,
                                animated: primitive.animated,
                                animated_delay: primitive.animated_delay,
                                position: {},
                                bg: {},
                                "data-primitive-type": "contact"
                            }
                            return <ButtonPrimitive 
                                key={item.id + "-" + item.sc}
                                i={i}
                                primitive={ _primitive } 
                            /> 
                        })
                } 
            </div> 
        </div>
        :
        <></>
}

const ContactsMobilePrimitive = (props: IPrimitiveProps): JSX.Element => { 
    const primitive: ContactsContent = useComponentData<ContactsContent>(( props.primitive || {dimentions: {}} ) as ContactsContent ) 
    const items: IMenuContact[] = primitive.items?.length  
        ?
        primitive.items
        :
        []
    let itemHeight = 50
    const cards =  items 
        .map((item, i) => {
            const _primitive : ButtonContent = { 
                id: (item.id || item.sc) as ID,
                type: LANDING_TYPE_CONTENT.BUTTON,
                label: item.label,
                icon: `${item.sc === SC.AT ? "fas" : "fab"} fa-${item.sc === SC.TELEGRAM ? `${item.sc}-plane` : item.sc}`,
                className: !!item.sc ? `soc hover ${item.sc} ${item.className}` : ``,
                url: item.url,
                image: item.image,
                imageWidth: item.imageWidth,
                imageHeight: item.imageHeight,
                design_type: item.design_type || primitive.design_type,
                animated: primitive.animated,
                animated_delay: primitive.animated_delay,
                position: {},
                bg: {}, 
                "data-primitive-type": "contact"
            }
            itemHeight = Math.max(itemHeight, parseInt((item.imageHeight || 50)?.toString()))
            return <ButtonPrimitive
                key={item.id + "-" + item.sc}
                i={i}
                primitive={ _primitive }
            />
        })
        
    return  !!items.length
        ?
        <div className={`pe-primitive-container landing-contacts-primitive w-100 px-4 ${primitive.className || ""}`}>
            <Gallery 
                items={ cards } 
                itemWidth="100%"                
                itemHeight={ itemHeight } 
                pagination={ false }
                navigation={ false }
                //navigationPositionType={ NAVIGATION_POSITION_TYPE.MIDDLE_INNER} 
                count={ primitive.carousel_count || 3 }
                loop 
                autoplay={3000}
                type="element"
                padding={ 30 }
            /> 
        </div>
        :
        <>NULL</>
}